export default {
    accept_document: "Qabul qilish",
    agreement_status_not_signed: "Imzolanmagan",
    agreement_status_signed: "Imzolangan",
    all_other_countries: "Boshqa barcha davlatlar",
    effective_at: "Kuchga kirish sanasi",
    legal_agreement: "Kelishuv",
    legal_document: "Yuridik hujjat",
    legal_document_countries_note: "Agar hech qanday davlat tanlanmasa, hujjat shu turdagi o'z hujjatiga ega bo'lmagan barcha davlatlarga tatbiq etiladi.",
    legal_document_is_active_note: "Har bir hujjat turi va mintaqasi uchun faqat bitta versiya faol bo'lishi mumkin. Ushbu versiyani faollashtirish oldingi faol versiyani avtomatik ravishda faolsizlantiradi.",
    legal_document_must_accept_note: "Davom etish uchun hujjat bilan tanishib, uni qabul qilishingiz kerak.",
    legal_document_superadmin_authority_note: "Hujjatni qabul qilish orqali siz tashkilot nomidan harakat qilish vakolatiga ega ekanligingizni tasdiqlaysiz.",
    legal_document_type: "Hujjat turi",
    legal_document_type_offer_contract: "Oferta shartnomasi",
    legal_document_type_integrations_agreement: "Uchinchi tomon xizmatlari va integratsiyalardan foydalanish shartnomasi",
    legal_document_type_usage_agreement: "Dasturdan foydalanish shartnomasi",
    legal_document_usage_agreement_note: "Hujjatni qabul qilish orqali siz dasturdan foydalanish qoidalari bilan tanishganingizni va ularga rioya qilish majburiyatini olganingizni tasdiqlaysiz.",
    legal_documents: "Yuridik hujjatlar",
    loading: "Yuklanmoqda",
    no_legal_documents_for_region: "Sizning mintaqangiz uchun hali hech qanday hujjat chop etilmagan",
    open_document: "Hujjatni ochish",
    requires_reacceptance: "Qayta qabul qilish talab qilinadi",
    requires_reacceptance_note: "Yoqilgan bo'lsa, oldingi versiyani qabul qilgan foydalanuvchilar keyingi kirishda ushbu versiyani qayta qabul qilishlari kerak bo'ladi.",
    version: "Versiya"
}
